/**
 * Single source of truth for the Vektor console (platform) version.
 *
 * Consumed by the sidebar footer (Navigation), Settings > System Info and the
 * Changelog header so they never drift apart again. Bump this on every release
 * and add the matching entry at the top of RELEASES in pages/Changelog.js.
 *
 * NOTE: this is the CONSOLE version. The Go agent binary has its own,
 * independent version served from /api/agent/go-version (manifest.json) and
 * shown on the Download page — do NOT reuse APP_VERSION there.
 */
export const APP_VERSION = '2.6.0';
